import { Injectable } from '@angular/core';
import {
  HTTPWrapperContext,
  REQUEST_METHODS,
  RequestConfigImplementation,
  XHR_STRATEGIES,
  AxwayTokenFetcherService
} from '@ptl/xhr';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FormValuesAsJson } from '../configs/interfaces/form.interface';
import { Brand, BrandingConfigurationService, brandCPA, brandDE, brandNENY, brandNEPA, brandSEPA, brandWNY, brandWPA, brandWV, brandMN } from '@ptl/brand';
import { CookieService } from 'ngx-cookie-service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { LinkShareValues } from './link-share-values.interface';
import { HttpParams } from '@angular/common/http';
import { HttpParameterCodec } from '@angular/common/http';
import { ZipCountyStateStructure } from '../../../interfaces/zipCountyStateStructure.interface';
import { API_ENDPOINTS } from 'src/app/shared/constants/api-endpoints.constant';
import { HttpHeaders } from '@angular/common/http';

enum INDIVIDUAL_MARKET_CONSUMER_REFERRAL_PAYLOAD_TYPE_ENUM {
  OFF_EXCHANGE_BLANK = 'OFFX_BLANK',
  ON_EXCHANGE_BLANK = 'ONX_BLANK',
  OFF_EXCHANGE_COMPLETE = 'OFFX_COMPLETE',
  ON_EXCHANGE_COMPLETE = 'ONX_COMPLETE',
  OFF_EXCHANGE_COMPLETE_SEP = 'OFFX_COMPLETE_SEP'
}

interface IndividualMarketConsumerReferralPayload {
  'type': INDIVIDUAL_MARKET_CONSUMER_REFERRAL_PAYLOAD_TYPE_ENUM;
  'attributes': [
    { 'name': 'TO_EMAIL', 'value': string },
    { 'name': 'AGENT_ID', 'value': string },
    { 'name': 'AGENCY_ID', 'value': string },
    { 'name': 'FROM_EMAIL', 'value': string },
    { 'name': 'AGENT_PHONE_NUM', 'value': string },
    { 'name': 'CLIENT_FIRST_NAME', 'value': string },
    { 'name': 'TELESALES', 'value': 'Y' | 'N' },
    { 'name': 'DDTOKEN', 'value': string },
    { 'name': 'IS_REFERRAL', 'value':string },
    { 'name': 'REGION', 'value': string }?
  ];
}

class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}


@Injectable({
  providedIn: 'root'
})

export class IndividualMarketConsumerReferralEmailService {
  constructor(
    private httpClient: HTTPWrapperContext,
    private reducerUtilityService: ReducerUtilityService,
    private brandingConfigurationService: BrandingConfigurationService,
    private commonUtilityService: CommonUtilityService,
    private cookieService: CookieService,
    private axwayTokenFetcherService: AxwayTokenFetcherService

  ) { }


  triggerLinkShareEmail(formValues: FormValuesAsJson, isTelesales: boolean, prependZeroes?: boolean) {
    try {

      let producerNumberRaw = null;
      let producerNumberFormatted = null;
      
      if (prependZeroes) {
        producerNumberRaw = formValues.producerNumber;
        producerNumberFormatted = new Array(10 - producerNumberRaw.length + 1).join('0') + producerNumberRaw;
      } else {
        producerNumberFormatted = formValues.producerNumber;
      }

      const agencyNumberRaw = formValues.agencyNumber;
      const agencyNumberFormatted = new Array(10 - agencyNumberRaw.length + 1).join('0') + agencyNumberRaw;

      const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();

      const payload: IndividualMarketConsumerReferralPayload = {
        type: INDIVIDUAL_MARKET_CONSUMER_REFERRAL_PAYLOAD_TYPE_ENUM.OFF_EXCHANGE_BLANK,
        attributes: [
          { name: 'TO_EMAIL', value: formValues.toEmailAddress },
          { name: 'AGENT_ID', value: producerNumberFormatted },
          { name: 'AGENCY_ID', value: agencyNumberFormatted },
          { name: 'FROM_EMAIL', value: formValues.fromEmailAddress },
          { name: 'AGENT_PHONE_NUM', value: formValues.agentPhoneNumber || '55555555555' },
          { name: 'CLIENT_FIRST_NAME', value: formValues.clientName },
          { name: 'TELESALES', value: isTelesales ? 'Y' : 'N' },
          { name: 'DDTOKEN', value: currentBrand.ddToken },
          { name: 'IS_REFERRAL', value: this.isMNRegion() ? 'TRUE' : 'FALSE'}
        ]
      };

      if (this.isNewYorkRegion() || this.isPARegion()) {
        payload.attributes.push({
          name: 'REGION',
          value: formValues.region
        });
      }else if(this.isWVRegion()){
        payload.attributes.push({
          name: 'REGION',
          value: 'WV'
        });
      }else if(this.isDERegion()){
        payload.attributes.push({
          name: 'REGION',
          value: 'DE'
        });
      }

      const jsonPayload = { payload: payload };
      const stringifiedPayload = JSON.stringify(jsonPayload);

      const host = window.location.hostname;
      let env = '';
      if (host.indexOf('env') >= 0) 
          env = 't' + host.substring(host.indexOf('env'), host.indexOf('.'));

      const requestConfig = new RequestConfigImplementation({
        method: REQUEST_METHODS.PUT,
        url: '/cmcrst/x-services/linkSharing/application',
        withCredentials: true,
        POST_OR_PUT_PAYLOAD: stringifiedPayload
      });

      this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
      return this.httpClient.makeRequest(requestConfig);
    } catch (e) {
      return Promise.reject(e);
    }
  }


  async getLinkShareEmailData(token) {

    const tokenResponse = await this.getEmailDataFromService(token)

    let tokenValues: LinkShareValues = {
      agencyID: null,
      agentID: null,
      agentACSId: null,
      subject: null,
      urlKey: token
    };

    let attributes = tokenResponse?.payload?.attributes;
    if (attributes?.length && attributes.length > 0) {
      attributes.forEach((item) => {
        switch (item.name) {
          case "AGENCY_ID":
            tokenValues.agencyID = item.value;
            break;
          case "AGENT_ID":
            tokenValues.agentID = item.value;
            break;
          case "SUBJECT":
            tokenValues.subject = item.value;
            break;
        }
      });

      const cookieNameToStore = "SHOP_FOUR_DOT_OH_EMAIL_PRODUCER_DATA";
      const cookieValue = window.btoa(JSON.stringify(tokenValues));
      this.cookieService.set(cookieNameToStore, cookieValue);

      return tokenValues;
    }

    return null;

  }
  async getEmailDataFromService(token) {

    // Original change used 'decodeURI', then subsequent changed used the custom encoder, this change solves the specific circumstance
    // of a reported priority issue, but I don't have any visibility into the scenarios where the previous changes were testable and 
    // working as intended.  I fully expect this to fail, perhaps for other ASPs?
    
    const decodedToken = decodeURIComponent(decodeURIComponent(token));

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: '/cmcrst/x-services/linkSharing/attribute',
      GET_PAYLOAD: {
        key: decodedToken
      }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    const response: any = await this.httpClient.makeRequest(requestConfig);
    return response;

  }

  storeToken(token) {
    this.commonUtilityService.saveQueryParams(token);
  }

  isNewYorkRegion(): boolean {
    const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();
    return currentBrand.region === brandNENY.region || currentBrand.region === brandWNY.region;
  }

  isPARegion(): boolean {
    const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();
    return currentBrand.region === brandSEPA.region || currentBrand.region === brandNEPA.region || currentBrand.region === brandCPA.region || currentBrand.region === brandWPA.region;
  }

  isWVRegion(): boolean {
    const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();
    return currentBrand.region === brandWV.region
  }

  isDERegion(): boolean {
    const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();
    return currentBrand.region === brandDE.region
  }

  isMNRegion(): boolean {
    const currentBrand: Brand = this.brandingConfigurationService.getCurrentBrand();
    return currentBrand.region === brandMN.region;
  }

}
